import Layout from '@/layout'

const villageRouter = {
  path: '/register',
  component: Layout,
  children: [
    {
      path: '/hotels/:name',
      name: 'hotels',
      meta: {
        title: '民宿旅馆',
      },
      component: () => import('@/views/hotel/home.vue'),
    },
    {
      path: '/hotels/moreRooms/:inTime/',
      name: 'hotelsMore',
      meta: {
        title: '樊营民宿村',
      },
      component: () => import('@/views/hotel/moreRooms.vue'),
    },
    {
      path: '/hotels/hotelsXq/:id/:integral',
      name: 'hotelsXq',
      meta: {
        title: '商品详情',
      },
      component: () => import('@/views/hotel/hotelsXq.vue'),
    },
    {
      path: '/hotels/store/:storeId',
      name: 'hotelsXq',
      meta: {
        title: '店铺详情',
      },
      component: () => import('@/views/hotel/store.vue'),
    },
    {
      path: '/hotels/settlement/:storeId/:storeName/:saleNum/:goodsId/:integral',
      name: 'settlement',
      meta: {
        title: '确认订单',
      },
      component: () => import('@/views/hotel/settlement.vue'),
    },
    {
      path: '/hotels/orderList/:id',
      name: 'orderList',
      meta: {
        title: '订单列表',
      },
      component: () => import('@/views/hotel/orderList.vue'),
    },
    {
      path: '/hotels/evaluate/:orderId/:goodsId',
      name: 'evaluate',
      meta: {
        title: '评价',
      },
      component: () => import('@/views/hotel/evaluate.vue'),
    },
    {
      path: '/hotels/evaluateList/:id',
      name: 'evaluateList',
      meta: {
        title: '评价列表',
      },
      component: () => import('@/views/hotel/evaluateList.vue'),
    },
    {
      path: '/hotels/myHotelsList',
      name: 'myHotelsList',
      meta: {
        title: '我的民宿旅馆',
      },
      component: () => import('@/views/hotel/myHotelsList.vue'),
    },
    {
      path: '/hotels/myHotelsXq/:hotelId',
      name: 'myHotelsXq',
      meta: {
        title: '民宿旅馆详情',
      },
      component: () => import('@/views/hotel/myHotelsXq.vue'),
    },
    {
      path: '/hotels/myHotelsList/addHotel/:add/:hotelId',
      name: 'addHotel',
      meta: {
        title: '编辑民宿旅馆',
      },
      component: () => import('@/views/hotel/addHotel.vue'),
    },
    {
      path: '/hotels/bindHotel',
      name: 'bindHotel',
      meta: {
        title: '绑定民宿',
      },
      component: () => import('@/views/hotel/bindHotel.vue'),
    },
    {
      path: '/hotels/myHotelsList/managerHotel/:hotelId',
      name: 'managerHotel',
      meta: {
        title: '设置管理员',
      },
      component: () => import('@/views/hotel/managerHotel.vue'),
    },
    {
      path: '/hotels/myHotelsList/myStaffList/:hotelId',
      name: 'myStaffList',
      meta: {
        title: '从业人员',
      },
      component: () => import('@/views/hotel/myStaffList.vue'),
    },
    {
      path: '/hotels/myHotelsList/myStaffList/addStaff/:add/:hotelId/:staffId',
      name: 'addStaff',
      meta: {
        title: '从业人员',
      },
      component: () => import('@/views/hotel/addStaff.vue'),
    },
    {
      path: '/hotels/myHotelsList/myGuestList/:hotelId',
      name: 'myGuestList',
      meta: {
        title: '旅客列表',
      },
      component: () => import('@/views/hotel/myGuestList.vue'),
    },
    {
      path: '/hotels/myHotelsList/roomList/:hotelId',
      name: 'roomList',
      meta: {
        title: '房间信息',
      },
      component: () => import('@/views/hotel/roomList.vue'),
    },
    {
      path: '/hotels/myHotelsList/myGuestListAll/:hotelId',
      name: 'myGuestListAll',
      meta: {
        title: '旅客信息',
      },
      component: () => import('@/views/hotel/myGuestListAll.vue'),
    },
    {
      path: '/hotels/myHotelsList/roomList/addRoom/:add/:roomId/:hotelId',
      name: 'addRoom',
      meta: {
        title: '房间信息',
      },
      component: () => import('@/views/hotel/addRoom.vue'),
    },
    {
      path: '/hotels/myHotelsList/myGuestList/roomGuestList/:roomCode/:hotelId/:roomId',
      name: 'roomGuestList',
      meta: {
        title: '旅客信息',
      },
      component: () => import('@/views/hotel/roomGuestList.vue'),
    },
    {
      path: '/job/jobList',
      name: 'jobList',
      meta: {
        title: '用工信息',
      },
      component: () => import('@/views/hotel/job/jobList.vue'),
    },
    {
      path: '/job/myJobList',
      name: 'myJobList',
      meta: {
        title: '用工信息',
      },
      component: () => import('@/views/hotel/job/myJobList.vue'),
    },
    {
      path: '/job/myJobList/jobListAdd/:add/:hotelId/:jobId',
      name: 'myJobList',
      meta: {
        title: '用工信息',
      },
      component: () => import('@/views/hotel/job/jobListAdd.vue'),
    },
    {
      path: '/job/myJobList/jobXq/:hotelId/:jobId',
      name: 'myJobList',
      meta: {
        title: '详情',
      },
      component: () => import('@/views/hotel/job/jobXq.vue'),
    },
    {
      path: '/hotels/myHotelsXq/roomType/:hotelId',
      name: 'roomType',
      meta: {
        title: '房间类型',
      },
      component: () => import('@/views/hotel/roomType/index.vue'),
    },
    {
      path: '/hotels/myHotelsXq/roomType/addRoomType/:add/:hotelId',
      name: 'addRoomType',
      meta: {
        title: '房间类型',
      },
      component: () => import('@/views/hotel/roomType/add.vue'),
    },
    {
      path: '/hotels/myHotelsXq/hotelOrder/:hotelId',
      name: 'hotelOrder',
      meta: {
        title: '订单管理',
      },
      component: () => import('@/views/hotel/hotelOrder/index.vue'),
    },
    {
      path: '/hotels/hotelsXq/reserve/:roomId/:start/:end/:amount',
      name: 'reserve',
      meta: {
        title: '预订',
      },
      component: () => import('@/views/hotel/reserve.vue'),
    },
    {
      path: '/hotel/myCheckIn',
      name: 'myCheckIn',
      meta: {
        title: '我的订单',
      },
      component: () => import('@/views/hotel/myCheckIn/index.vue'),
    },
    {
      path: '/hotel/myCheckIn/cherkInXq/:preId',
      name: 'cherkInXq',
      meta: {
        title: '订单详情',
      },
      component: () => import('@/views/hotel/myCheckIn/cherkInXq.vue'),
    },
    {
      path: '/hotel/pingJia/index/:preId',
      name: 'pingJia',
      meta: {
        title: '订单评价',
      },
      component: () => import('@/views/hotel/pingJia/index.vue'),
    },
    {
      path: '/hotels/myHotelsXq/hotelOrder/hotelOrderXq/:hotelId/:preId',
      name: 'hotelOrderXq',
      meta: {
        title: '入住订单详情',
      },
      component: () => import('@/views/hotel/hotelOrder/hotelOrderXq.vue'),
    },
  ],
}

export default villageRouter
